import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Layer } from '../../entities/layers/layer';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class LayerService {
  // Define API
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch layer list
  getLayers(): Observable<Layer> {
    return this.http.get<Layer>(this.apiURL + '/getcapa')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API get() method => Fetch layer
  getLayer(id): Observable<Layer> {
    return this.http.get<Layer>(this.apiURL + '/capa/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Create layer
  createLayer(layer): Observable<Layer> {
    return this.http.post<Layer>(this.apiURL + '/capa/0', JSON.stringify(layer), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API put() method => Update layer
  updateLayer(id, layer): Observable<Layer> {
    return this.http.put<Layer>(this.apiURL + '/capa/' + id, JSON.stringify(layer), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete layer
  deleteLayer(id) {
    return this.http.delete<Layer>(this.apiURL + '/capa/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Codigo Error (layer): ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
